import { createAction } from "@reduxjs/toolkit";


import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { AUTHENTICATING_DATA_SOURCE, AUTHENTICATING_DATA_SOURCE_FAILED, AUTHENTICATING_DATA_SOURCE_SUCCEEDED, CREATING_DATA_SOURCE_MAPPING_FAILED, CREATING_DATA_SOURCE_MAPPING_REQUEST, CREATING_DATA_SOURCE_MAPPING_SUCCEEDED, CREATING_RSS_DATA_SOURCE, CREATING_RSS_DATA_SOURCE_FAILED, CREATING_RSS_DATA_SOURCE_SUCCEEDED, DELETING_DATA_SOURCE, DELETING_DATA_SOURCE_FAILED, DELETING_DATA_SOURCE_MAPPING_FAILED, DELETING_DATA_SOURCE_MAPPING_REQUEST, DELETING_DATA_SOURCE_MAPPING_SUCCEEDED, DELETING_DATA_SOURCE_SUCCEEDED, FETCHING_DATA_SOURCE_CHILDREN_FAILED, FETCHING_DATA_SOURCE_CHILDREN_REQUEST, FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED, FETCHING_DATA_SOURCE_MAPPINGS_FAILED, FETCHING_DATA_SOURCE_MAPPINGS_REQUEST, FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED, FETCHING_DATA_SOURCES_FAILED, FETCHING_DATA_SOURCES_REQUEST, FETCHING_DATA_SOURCES_SUCCEEDED, INVALIDATE_DATA_SOURCE_DELETION, INVALIDATE_DATA_SOURCE_MIGRATION_STATUS, INVALIDATE_DATA_SOURCE_SYNC, MIGRATING_DATA_SOURCE, MIGRATING_DATA_SOURCE_FAILED, MIGRATING_DATA_SOURCE_SUCCEEDED, SYNCING_DATA_SOURCE, SYNCING_DATA_SOURCE_FAILED, SYNCING_DATA_SOURCE_MAPPING_FAILED, SYNCING_DATA_SOURCE_MAPPING_REQUEST, SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED, SYNCING_DATA_SOURCE_SUCCEEDED } from "./actionTypes";
import buildUrl from "build-url-ts";
import { CreateDataSourceMappingError, CreateDataSourceMappingRequest, CreateDataSourceMappingResponse, DeleteDataSourceMappingError, DeleteDataSourceMappingRequest, DeleteDataSourceMappingResponse, FetchDataSourceChildrenError, FetchDataSourceChildrenRequest, FetchDataSourceChildrenResponse, FetchDataSourceError, FetchDataSourceMappings, FetchDataSourceMappingsError, FetchDataSourceMappingsResponse, FetchDataSourceRequest, FetchDataSourceResponse, SyncDataSourceMappingError, SyncDataSourceMappingRequest, SyncDataSourceMappingResponse } from "../../types/dataSource";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const DATA_SOURCE_BASE_URL = `${apiUrl}/api/2.0`;
const SOURCE_URL = `${DATA_SOURCE_BASE_URL}/datasources`;

export const fetchDataSource = createAction<FetchDataSourceRequest>(FETCHING_DATA_SOURCES_REQUEST);

const fetchingDataSourceSucceeded = createAction<FetchDataSourceResponse>(FETCHING_DATA_SOURCES_SUCCEEDED);

const fetchingDataSourceFailed = createAction<FetchDataSourceError>(FETCHING_DATA_SOURCES_FAILED);

const fetchDataSourceSaga = function* (action: ReturnType<typeof fetchDataSource>): any {

  const url = new URL(`${SOURCE_URL}/summary`);

  const fetchDataSourceAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDataSourceAPI);
    yield put(fetchingDataSourceSucceeded({datasources: response}));
  } catch (error) {
    yield put(fetchingDataSourceFailed({error}));
  }
};

export const fetchDataSourceMappings = createAction<FetchDataSourceMappings>(FETCHING_DATA_SOURCE_MAPPINGS_REQUEST);

const fetchingDataSourceMappingsSucceeded = createAction<FetchDataSourceMappingsResponse>(FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED);

const fetchingDataSourceMappingsFailed = createAction<FetchDataSourceMappingsError>(FETCHING_DATA_SOURCE_MAPPINGS_FAILED);

const fetchDataSourceMappingsSaga = function* (action: ReturnType<typeof fetchDataSourceMappings>): any {
  const entity = action.payload.entity;
  const id = entity.id;
  const type = entity.entityType;

  const url = `${SOURCE_URL}/mapping?id=${id}&type=${type}`;

  const updateAssetAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    yield put(fetchingDataSourceMappingsSucceeded({mappings: response}));
  } catch (error) {
    yield put(fetchingDataSourceMappingsFailed({error}));
  }
};

export const fetchDataSourceChildren = createAction<FetchDataSourceChildrenRequest>(FETCHING_DATA_SOURCE_CHILDREN_REQUEST);

const fetchingDataSourceChildrenSucceeded = createAction<FetchDataSourceChildrenResponse>(FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED);

const fetchingDataSourceChildrenFailed = createAction<FetchDataSourceChildrenError>(FETCHING_DATA_SOURCE_CHILDREN_FAILED);

const fetchDataSourceChildrenSaga = function* (action: ReturnType<typeof fetchDataSourceChildren>): any {
  
  const account = action.payload.account;
  const parent = action.payload.parent;
  const showFile = action.payload.showFile;


  var url = buildUrl(SOURCE_URL, {
    path: `${account}/children`,
  });

  const updateAssetAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: {
        parent: parent,
        showFile: showFile,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateAssetAPI);
    yield put(fetchingDataSourceChildrenSucceeded({children: response, account, parent}));
  } catch (error) {
    yield put(fetchingDataSourceChildrenFailed({error, account}));
  }
};

//create data source mapping
export const createDataSourceMapping = createAction<CreateDataSourceMappingRequest>(CREATING_DATA_SOURCE_MAPPING_REQUEST);

const createDataSourceMappingSucceeded = createAction<CreateDataSourceMappingResponse>(CREATING_DATA_SOURCE_MAPPING_SUCCEEDED);

const createDataSourceMappingFailed = createAction<CreateDataSourceMappingError>(CREATING_DATA_SOURCE_MAPPING_FAILED);

const createDataSourceMappingSaga = function* (action: ReturnType<typeof createDataSourceMapping>): any {
  const source = action.payload.source;
  const request = action.payload.request;
  const event = action.payload.event;

  const url = `${SOURCE_URL}/${source}/mapping`;

  const createAssetAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createAssetAPI);
    yield put(createDataSourceMappingSucceeded({ mapping: response, source}));
    event({response});

    yield put(syncDataSourceMapping({ id: response.id }));
  } catch (error) {
    yield put(createDataSourceMappingFailed({error, source}));
  }
};

//sync data source mapping
export const syncDataSourceMapping = createAction<SyncDataSourceMappingRequest>(SYNCING_DATA_SOURCE_MAPPING_REQUEST);

const syncDataSourceMappingSucceeded = createAction<SyncDataSourceMappingResponse>(SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED);

const syncDataSourceMappingFailed = createAction<SyncDataSourceMappingError>(SYNCING_DATA_SOURCE_MAPPING_FAILED);

const syncDataSourceMappingSaga = function* (action: ReturnType<typeof syncDataSourceMapping>): any {

  const mappingId = action.payload.id;

  const url = `${SOURCE_URL}/mapping/${mappingId}/sync`;

  const createAssetAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createAssetAPI);
    yield put(syncDataSourceMappingSucceeded({mapping: response}));
  } catch (error) {
    yield put(syncDataSourceMappingFailed({error, mappingId}));
  }
};

//delete data source mapping
export const deleteDataSourceMapping = createAction<DeleteDataSourceMappingRequest>(DELETING_DATA_SOURCE_MAPPING_REQUEST);

const deleteDataSourceMappingSucceeded = createAction<DeleteDataSourceMappingResponse>(DELETING_DATA_SOURCE_MAPPING_SUCCEEDED);

const deleteDataSourceMappingFailed = createAction<DeleteDataSourceMappingError>(DELETING_DATA_SOURCE_MAPPING_FAILED);

const deleteDataSourceMappingSaga = function* (action: ReturnType<typeof deleteDataSourceMapping>): any {
  const mappingId = action.payload.id;

  const url = `${SOURCE_URL}/mapping/${mappingId}`;

  const deleteAssetAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAssetAPI);
    yield put(deleteDataSourceMappingSucceeded({mappingId}));
  } catch (error) {
    yield put(deleteDataSourceMappingFailed({error, mappingId}));
  }
};

//authenticate data source
export const authenticateDataSource = createAction<{sourceType: string, code: string}>(AUTHENTICATING_DATA_SOURCE);

const authenticatingDataSourceSucceeded = createAction<any>(AUTHENTICATING_DATA_SOURCE_SUCCEEDED);

const authenticatingDataSourceFailed = createAction<any>(AUTHENTICATING_DATA_SOURCE_FAILED);

const authenticateDataSourceSaga = function* (action: ReturnType<typeof authenticateDataSource>): any {

  const sourceType = action.payload.sourceType;
  const code = action.payload.code;

  const url = `${SOURCE_URL}/${sourceType}/authenticate`;

  const authenticateDataSourceAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: {
        code: code,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(authenticateDataSourceAPI);
    yield put(authenticatingDataSourceSucceeded({sourceType, response}));
  } catch (error) {
    yield put(authenticatingDataSourceFailed({error, sourceType}));
  }
};

//delete data source
export const deleteDataSource = createAction<{id: string}>(DELETING_DATA_SOURCE);

const deletingDataSourceSucceeded = createAction<any>(DELETING_DATA_SOURCE_SUCCEEDED);

const deletingDataSourceFailed = createAction<any>(DELETING_DATA_SOURCE_FAILED);

const deleteDataSourceSaga = function* (action: ReturnType<typeof deleteDataSource>): any {
  const id = action.payload.id;

  const url = `${SOURCE_URL}/${id}`;

  const deleteDataSourceAPI = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteDataSourceAPI);
    yield put(deletingDataSourceSucceeded({id}));
  } catch (error) {
    yield put(deletingDataSourceFailed({error, id}));
  }
};

//sync data source
export const syncDataSource = createAction<any>(SYNCING_DATA_SOURCE);

const syncingDataSourceSucceeded = createAction<any>(SYNCING_DATA_SOURCE_SUCCEEDED);

const syncingDataSourceFailed = createAction<any>(SYNCING_DATA_SOURCE_FAILED);

const syncDataSourceSaga = function* (action: ReturnType<typeof syncDataSource>): any {
  const id = action.payload.id;

  const url = `${SOURCE_URL}/${id}/sync`;

  const syncDataSourceAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(syncDataSourceAPI);
    yield put(syncingDataSourceSucceeded({id}));
  } catch (error) {
    yield put(syncingDataSourceFailed({error, id}));
  }
};

//migrate data source
export const migrateDataSource = createAction<any>(MIGRATING_DATA_SOURCE);

const migratingDataSourceSucceeded = createAction<any>(MIGRATING_DATA_SOURCE_SUCCEEDED);

const migratingDataSourceFailed = createAction<any>(MIGRATING_DATA_SOURCE_FAILED);

const migrateDataSourceSaga = function* (action: ReturnType<typeof migrateDataSource>): any {
  const id = action.payload.id;

  const url = `${SOURCE_URL}/${id}/migrate`;

  const migrateDataSourceAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(migrateDataSourceAPI);
    yield put(migratingDataSourceSucceeded({response}));
  } catch (error) {
    yield put(migratingDataSourceFailed({error, id}));
  }
};


//create rss data source 
export const createRssDataSource = createAction<{sourceType: string, rssUrl: string}>(CREATING_RSS_DATA_SOURCE);

const creatingRssDataSourceSucceeded = createAction<any>(CREATING_RSS_DATA_SOURCE_SUCCEEDED);

const creatingRssDataSourceFailed = createAction<any>(CREATING_RSS_DATA_SOURCE_FAILED);

const createRssDataSourceSaga = function* (action: ReturnType<typeof createRssDataSource>): any {
  
  const sourceType = action.payload.sourceType;
  const rssUrl = action.payload.rssUrl;
  
  const url = `${SOURCE_URL}/${sourceType}`;

  const createRssDataSourceAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: {
        rssUrl: rssUrl
      }
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createRssDataSourceAPI);
    yield put(creatingRssDataSourceSucceeded({sourceType, source: response}));
  } catch (error) {
    yield put(creatingRssDataSourceFailed({sourceType, error}));
  }
};


export const invalidateDataSourceSync = createAction(INVALIDATE_DATA_SOURCE_SYNC);
export const invalidateDataSourceDeletion = createAction(INVALIDATE_DATA_SOURCE_DELETION);
export const invalidateMigrationStatus = createAction<{id: string}>(INVALIDATE_DATA_SOURCE_MIGRATION_STATUS);

export default function* dataSourceSaga() {
  yield takeEvery(FETCHING_DATA_SOURCES_REQUEST, fetchDataSourceSaga);
  yield takeEvery(FETCHING_DATA_SOURCE_MAPPINGS_REQUEST, fetchDataSourceMappingsSaga);
  yield takeEvery(FETCHING_DATA_SOURCE_CHILDREN_REQUEST, fetchDataSourceChildrenSaga);
  yield takeEvery(CREATING_DATA_SOURCE_MAPPING_REQUEST, createDataSourceMappingSaga);
  yield takeEvery(SYNCING_DATA_SOURCE_MAPPING_REQUEST, syncDataSourceMappingSaga);
  yield takeEvery(DELETING_DATA_SOURCE_MAPPING_REQUEST, deleteDataSourceMappingSaga);
  yield takeEvery(AUTHENTICATING_DATA_SOURCE, authenticateDataSourceSaga);
  yield takeEvery(DELETING_DATA_SOURCE, deleteDataSourceSaga);
  yield takeEvery(SYNCING_DATA_SOURCE, syncDataSourceSaga);
  yield takeEvery(MIGRATING_DATA_SOURCE, migrateDataSourceSaga);
  yield takeEvery(CREATING_RSS_DATA_SOURCE, createRssDataSourceSaga);
}